export default __webpack_public_path__ + "static/media/et-plus@3x.711955b2.png";